import React, {useEffect, useState} from 'react'
import {useLoaderData} from "react-router-dom";
import {Grid131313} from "../widgets/Grids";
import Link from "../widgets/Link";
import {useApi} from "../ApiSession";



export default ({ children }) => {

    const users = useLoaderData()

    const api = useApi()

    const [currentUser, setCurrentUser] = useState(null);


    useEffect(() => {
        api.getMe().then(setCurrentUser)
    }, []);


    const personify = user_id =>
        api.doPersonify(user_id).then(() => {
            api.getMe().then(res => {
                setCurrentUser(res)
            })
        })

    return <Grid131313>
        {currentUser && <h1>Utilisateur Courrant {currentUser.email}</h1>}
        <h1>Utilisateurs du registre</h1>
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead>
            <tr>
                <th>courriel</th>
                <th>date d'activation</th>
                <th>admin</th>
                <th>dossiers</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {users.map(user =>
                <tr
                    key={`tr-${user.id}`}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                >
                    <td>{user.email}</td>
                    <td>{user.activated_at}</td>
                    <td>{user.is_admin ? 'admin' : ''}</td>
                    <td>{user.n_dossiers}</td>
                    <td><Link caption={"personifier"} onClick={() => personify(user.id)}/></td>
                </tr>
            )}
            </tbody>
        </table>
    </Grid131313>
}